// React
import { useState, useEffect } from 'react';

// Material UI
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';
import Button from "@mui/material/Button";

// Owned
import DonationOptions from "./DonationOptions";
import { DONATION_TYPES } from './Constants';
import { createCheckoutSession } from './stripe';

const Donations = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [currency, setCurrency] = useState("$ USD");
    const [donationValue, setDonationValue] = useState(10);
    const [customValue, setCustomValue] = useState(null);
    const [donationType, setDonationType] = useState(DONATION_TYPES.ONE_TIME);

    const [amount, setAmount] = useState(null);

    const handleDonate = async () => {
        setIsLoading(true);
        try {
            const response = await createCheckoutSession(customValue || donationValue, donationType, currency.split(" ")[1]);
            setIsLoading(false);
            window.location.href = response.data.url;
        } catch(e) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        setAmount(customValue || donationValue);
    }, [customValue, donationValue])

    return(
        <Container>
            <Box 
                m="auto"
                sx={{ 
                    marginTop: '100px',
                    paddingBottom: '100px'
                }}
            >    
                <Typography variant="h4">
                    Donate to Super Agent
                </Typography>
                <br />
                <Typography 
                    variant="body1"
                >
                    Hi, we hope you are enjoying Super Agent! 
                    Super Agent is a free extension that helps enforce your cookie preferences so you never have to see any cookie pop-ups again. 
                    This requires constant work and we rely on donations to keep going.
                </Typography>
                <DonationOptions 
                    currency={currency}
                    setCurrency={setCurrency}
                    donationValue={donationValue}
                    setDonationValue={setDonationValue}
                    customValue={customValue}
                    setCustomValue={setCustomValue}
                    donationType={donationType}
                    setDonationType={setDonationType}
                />
                {isLoading ? 
                    <CircularProgress />
                    :
                    <Button 
                        variant="outlined" 
                        color="primary"
                        onClick={handleDonate}
                        disabled={amount < 3}
                    >
                        Donate
                    </Button>
                }
                <Typography 
                    variant="body2"
                    sx={{
                        marginTop: '10px'
                    }}
                >
                    You'll be redirected to Stripe for secure payment. Super Agent does not have access to any payment information.
                </Typography>
                {amount < 3 ? 
                    <Typography variant="body2" sx={{ color: 'red' }}>
                        Donations must be at least $3.00 to cover fees.
                    </Typography>
                    :
                    null
                }
            </Box>
        </Container>
    )
}

export default Donations;
